import React, { useEffect } from "react";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Variable from "./variable/variable";

import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as CommonFunctions from "./functions/commonFunctions";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as GC from "../../../common/common";
import { CONSTS } from "../../../common/const";
import bijlage from "../../../../content/images/bijlage.svg";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
    this.treeClickName = null;
    window.$catalog_budget_context = this
  }

  reloadData(page_number, ids, short_type, direction, field, content = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [],
          definitions: [],
        };
      } else {
        model = {
          content: content,
          definitions: [],
          sorting: [],
        };
        window.$catalog_budget_result = [];
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [],
        };
      } else {
        model = {
          content: content,
          definitions: [],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }

    //** seçilmiş ağaca göre verilerin nasıl geleceğinin kontrolü yapılıyor.
    if (
      !window.$catalog_budget_last_tree_click.budget &&
      !window.$catalog_budget_last_tree_click.grootboek
    ) {
      model.definitions.push(
        process.env.REACT_APP_CATALOG_BUDGET,
        process.env.REACT_APP_GROOTBOEK
      );
    } else if (window.$catalog_budget_last_tree_click.budget) {
      model.definitions.push(process.env.REACT_APP_CATALOG_BUDGET);
    } else model.definitions.push(process.env.REACT_APP_GROOTBOEK);

    window.$catalog_budget_lastUsedTableFilter = model;
    window.$catalog_budget_context.fillTable(model, page_number).then(() => {
      window.$catalog_budget_context.fillFilterColumns();
    });

  }
  fillFilterColumns() {
    var that = this;
    var model = {
      definitions: [
        window.$catalog_budget_last_tree_click.budget
          ? process.env.REACT_APP_CATALOG_BUDGET
          : process.env.REACT_APP_GROOTBOEK,
      ],
    };
    $.each(window.$catalog_budget_columnList, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }
  async fillTable(model, page_number) {
    var that = this;
    window.$catalog_budget_lastUsedTableFilter = model;

    window.$catalog_budget_treeChangeStatus = false;
    window.$catalog_budget_scroll_change = false;

    omnimap
      .FillTableAction(
        model,
        page_number,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.FillTableCallBack(
          result,
          page_number,
          window.$catalog_budget_columnListPure
        );
      });
  }

  clickReload(){
    $("#cover-spin").show(0);
    // $("#spinner").removeAttr("hidden");

    window.$catalog_budget_context.reloadData(1);

    // that.reloadData(1);
  };

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$catalog_budget_filterContent, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$catalog_budget_filterContent = $.grep(
        window.$catalog_budget_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$catalog_budget_filterContent.push(contentModel);
    }

    var model = {
      content: window.$catalog_budget_filterContent,
      definitions: [
        process.env.REACT_APP_CATALOG_BUDGET,
        process.env.REACT_APP_GROOTBOEK,
      ],
    };

    this.reloadData(
      1,
      window.$catalog_budget_result,
      null,
      null,
      null,
      window.$catalog_budget_filterContent
    );
  }
  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [
        window.$catalog_budget_last_tree_click.budget
          ? process.env.REACT_APP_CATALOG_BUDGET
          : process.env.REACT_APP_GROOTBOEK,
      ],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  GetActionsOfRow(rowIds) {
    omnimap
      .GetActionsOfRowAction(rowIds, window.$catalog_management_units_token)
      .then((result) => {
        CallBackFunctions.GetActionsOfRowCallback(result, this.treeClickName, rowIds.length);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$catalog_budget_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        // *ağaçların hiçbiri seçilmezse
        window.$catalog_budget_last_tree_click.budget = false;
        window.$catalog_budget_last_tree_click.grootboek = false;

        var model = {
          content: [],
          definitions: [
            process.env.REACT_APP_CATALOG_BUDGET,
            process.env.REACT_APP_GROOTBOEK,
          ],
        };
        // that.setState({ lastUsedTableFilter: model });
        window.$catalog_budget_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        //** hangi tree'ye tıklandığını kontrol edip ona göre search filter geliyor
        CommonFunctions.treeClickControl(that.props.location.state.id);

        let treeClickName =
          that.props.location.state.TreeList &&
          that.props.location.state.TreeList.filter((x) => x.isOpen === true);

        this.treeClickName =
          treeClickName && treeClickName[treeClickName.length - 1].name;

        let model = {
          definitions: [that.props.location.state.id],
        };
        this.fillTable(model, 1);
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          // alert( "This page is reloaded" );
          CommonFunctions.treeClickControl(that.props.location.state.id);

          let model = {
            definitions: [that.props.location.state.id],
          };
          this.fillTable(model, 1);
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      //** hangi tree'ye tıklandığını kontrol edip ona göre search filter geliyor
      CommonFunctions.treeClickControl(that.props.location.state.id);
      let treeClickName =
        that.props.location.state.TreeList &&
        that.props.location.state.TreeList.filter((x) => x.isOpen === true);

      this.treeClickName =
        treeClickName && treeClickName[treeClickName.length - 1].name;
      let model = {
        definitions: [that.props.location.state.id],
      };
      this.fillTable(model, 1);

      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_FINANCIAL
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$catalog_budget_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_FINANCIAL;
        window.$catalog_budget_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_FINANCIAL;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$catalog_budget_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_FINANCIAL,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>financial"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : item === "paperclip" ? (
              <th className="sorting_disabled">
                <img
                    className="icon-table"
                    src={bijlage}
                    width={18}
                    height={18}
                />
              </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$catalog_budget_columnListPure = result;
      }
    }
    /***************************************************************************************/

    if (window.$catalog_management_units_token == null) {
      window.$catalog_management_units_token = GC.GetToken().then((token) => {
        window.$catalog_management_units_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>budget") {
        window.$catalog_budget_columnList = item["column-list"];
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,
      scrollX: "", //"500px",

      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      destroy: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_FINANCIAL
        );
        window.$catalog_budget_columnListPure = result;
      },
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$catalog_budget_columnListPure.column_list[idx] === "checkbox" ||
        window.$catalog_budget_columnListPure.column_list[idx] === "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_budget_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }

      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_budget_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$catalog_budget_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$catalog_budget_page_number++;
                that.fillTable(
                  window.$catalog_budget_lastUsedTableFilter,
                  window.$catalog_budget_page_number
                );
              }
            } else window.$catalog_budget_scroll_change = true;
          }
        }
      }
    });

    /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
    $("#example thead tr").clone(true).appendTo("#example thead");
    $("#example thead tr th").removeClass("sorting_asc");

    $(table.table().header()).addClass("scrollabe-datatable");

    document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
      "scrollabe-datatable-id";

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(window.$catalog_budget_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();

      if (row_index != undefined && row_index != 0) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "col-search ui-autocomplete-input" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (row_index) {
            if (this.className == "sorting_disabled") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$catalog_budget_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$catalog_budget_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$catalog_budget_filterContent
              );
            } else if (this.className == "sorting_asc") {
              this.className = "sorting_desc";
              var row;
              $.each(window.$catalog_budget_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$catalog_budget_result,
                row.shortType,
                "DESCENDING",
                row.shortField,
                window.$catalog_budget_filterContent
              );
            } else if (this.className == "sorting_desc") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$catalog_budget_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$catalog_budget_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$catalog_budget_filterContent
              );
            }
          }

          window.$catalog_budget_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$catalog_budget_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$catalog_budget_selectedRow = data;
          that.props.history.push("/catalog/financial/detail/" + rowId, {
            rowData: data,
          });
        }
      });

      // fillDetail();
      // CommonFunctions.fillDetail();
      // $("#tableSide").addClass("d-none");
      // $("#detailSide").removeClass("d-none");
    });

    /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });

    $("#algemeen-code").autocomplete({
      source: window.$catalog_budget_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naam").autocomplete({
      source: window.$catalog_budget_algemeenNaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-naam").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-jaar").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.reloadData(1);
    }
    window.$catalog_budget_refresh = handleRefresh;

    $(".refresh").click(handleRefresh);

    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      // that.setState({ selectedIds: selectedIds });
      window.$catalog_budget_selectedIds = selectedIds;
      that.GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#verwijderen", function () {
      if (window.$catalog_budget_selectedIds === 0) {
        alert("rows not selected");
      } else {
        $("#budget-mappen_beheren_delete_modal").modal("show");
      }
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Type</th>
              <th>Naam</th>
              <th>Code</th>
              <th style={{ minWidth: 200 }}>Omschrijving</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
